export default __webpack_public_path__ + "static/media/demo-3.e37a7353.png";